// extracted by mini-css-extract-plugin
export var HideOnDesktop = "HeaderUserProfileLink-module--HideOnDesktop--4ded0";
export var HideOnMobile = "HeaderUserProfileLink-module--HideOnMobile--88ce6";
export var RTL = "HeaderUserProfileLink-module--RTL--c5848";
export var Username = "HeaderUserProfileLink-module--Username--608bd";
export var fadeAndGrowIn = "HeaderUserProfileLink-module--fadeAndGrowIn--bdab3";
export var user = "HeaderUserProfileLink-module--user--c70d8";